// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"164":"dd91cc08253e708b","185":"85623a60197ea11a"}[chunkId] + ".css";
};